import { render, staticRenderFns } from "./ImpedimentosOrtopedicos.vue?vue&type=template&id=56fdf41e"
import script from "./ImpedimentosOrtopedicos.vue?vue&type=script&lang=js"
export * from "./ImpedimentosOrtopedicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports